import AddIcon from '@atlaskit/icon/core/add';
import React from 'react';

export const SvgAdd = () => <AddIcon label="" testId="ads-refreshed-icon" />;
